export default "__VITE_ASSET__Dv7zaWZW__"